import React from "react";

import {
  StyledActionsPanelWrapper,
} from "./styled";
import { MobilePanel } from "./comps/MobilePanel";
import { DesktopPanel } from "./comps/DesktopPanel";

export const ActionsPanel = (props) => {

  const {
  showSideBarLeft,
  isMobile,

  actionRef,
  actionsPanelStickyTop,
  
  style = {},
  } = props
  
  return (
    <StyledActionsPanelWrapper
      style={{
        ...style,
      }}
      ref={actionRef}
      sidebar={showSideBarLeft}
      isMobile={isMobile}
      actionsPanelStickyTop={actionsPanelStickyTop}
    >
      {isMobile ? (
        <MobilePanel {...props} />
      ) : (
        <DesktopPanel {...props} />
      )}
    </StyledActionsPanelWrapper>
  );
};
